import React, { useId } from "react";

import { Field, FieldError, FieldLabel } from "@/src/components/ui/field";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/src/components/ui/select";

import type { JSX } from "react";

import type { SelectFieldOption } from "./formFields.types";

interface SelectFieldBaseProps {
  label: string;
  value: string;
  options: SelectFieldOption[];
  onValueChange: (value: string) => void;
  disabled?: boolean;
  error?: string;
}

// eslint-disable-next-line import-x/prefer-default-export -- named like the other XxxFieldBase exports
export function SelectFieldBase({
  label,
  value,
  options,
  onValueChange,
  disabled,
  error,
}: SelectFieldBaseProps): JSX.Element {
  const id = useId();

  return (
    <Field>
      <FieldLabel htmlFor={id}>{label}</FieldLabel>
      <Select disabled={disabled} onValueChange={onValueChange} value={value}>
        <SelectTrigger aria-invalid={error ? true : undefined} id={id}>
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {options.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <FieldError>{error}</FieldError>
    </Field>
  );
}
